var map = {
	"./arrow-back.svg": 273,
	"./arrow-down-big.svg": 274,
	"./arrow-down.svg": 227,
	"./arrow-left-big.svg": 275,
	"./arrow-left.svg": 205,
	"./arrow-next.svg": 276,
	"./arrow-right-fixed.svg": 277,
	"./arrow-right.svg": 206,
	"./arrow-up.svg": 255
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 254;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg ^\.\/arrow\-.*\.svg$
// module id = 254
// module chunks = 0 5 6 14